import { useCallback } from 'react'
import { usePostHog } from '@posthog/react'

export type ProductEventName =
  | 'chatgpt_workspace_opened'
  | 'signup_completed'
  | 'hosting_started'
  | 'event_created'
  | 'camera_created'
  | 'camera_invite_copied'
  | 'camera_invite_shared'
  | 'first_camera_video'
  | 'obs_setup_downloaded'
  | 'first_programme_video'
  | 'public_event_link_copied'
  | 'live_hero_opened'
  | 'live_hero_live'
  | 'live_hero_located'
  | 'live_hero_create_event'

export type ProductEventProperties = {
  event_id?: string
  camera_id?: string
  programme_id?: string
  camera_count?: number
  method?: string
}

/** Product events carry resource IDs and counts, never names, URLs or credentials. */
export function useProductEvent(eventId?: string) {
  const posthog = usePostHog()
  return useCallback(
    (
      name: ProductEventName,
      properties: ProductEventProperties = {},
    ): boolean => {
      if (
        !import.meta.env.VITE_POSTHOG_PROJECT_TOKEN?.trim() ||
        !posthog?.__loaded
      )
        return false
      try {
        return Boolean(
          posthog.capture(name, {
            ...(new URLSearchParams(window.location.search).get('entry_surface') === 'chatgpt'
              ? {entry_surface: 'chatgpt', plugin_contract_version: '1'} : {}),
            ...(eventId ? { event_id: eventId } : {}),
            ...properties,
          }),
        )
      } catch {
        // Analytics must never turn a successful camera action into a product error.
        return false
      }
    },
    [eventId, posthog],
  )
}
